import type { IFupLogo } from "@bbj-types/organisation";
import { useSuspense } from "@root/api/tools/axios";
import { settingsAxiosInstance } from ".";

export type TGetFupLogosResponse = IFupLogo[];

export const useSuspenseGetFupLogos = () => {
  return useSuspense(
    () =>
      settingsAxiosInstance.get<TGetFupLogosResponse>("/fup/logos", {
        withCredentials: true,
      }),
    []
  );
};
